import { Skeleton } from "antd";
import React from "react";

export default function ChartLoader() {
  return (
    <div>
      <div className="card h-100">
        <div className="card-header pt-2">
          <h3 className="card-title align-items-start flex-column">
            <Skeleton.Button active={true} />
          </h3>
        </div>
        <div
          className="card-body d-flex align-items-center justify-content-between"
          style={{ columnGap: "1rem" }}
        >
          <Skeleton active={true} paragraph={{ rows: 5 }} />
        </div>
      </div>
    </div>
  );
}
